import React, { Component } from 'react'

const ROOT = '/'

export function getPath() {
  return typeof window !== 'undefined' ? window.location.pathname : ROOT
}

export class LinksGroupContainer extends Component {
  constructor(props) {
    super(props)
  }

  specific(link) {
    if (link.slug !== null) {
      return this.props.block_name + '__list-item' + link.slug
    }
    return ''
  }

  shouldRemoveLink(link) {
    let path = getPath().split('/').pop()
    return this.props.remove_selected && path !== '/' && link.slug === path
  }

  getLinkItem(link, index) {
    return (
      <li key={index} className={`${this.props.block_name}__list-item ${this.specific(link)}`}>
        <a
          title={link.title}
          href={link.url}
          target={this.props.target}
          className={link.class_name_for_list_item_anchor}
          data-analytics-event-category={this.props.analytics_event_category}
          data-analytics-event-action={this.props.analytics_event_action}
          data-analytics-event-label={link.analytics_event_label_at}
        >
          {link.image
            ? <img
                src={link.image}
                alt={link.title}
                className={`${this.props.block_name}__list-item-image`}
              />
            : null}
          {link.title ? link.title : ''}
        </a>
      </li>
    )
  }

  render() {
    return (
      <section
        className={`${this.props.block_name}  ${this.props.block_name}--${this.props.modifier}`}
      >
        {this.props.header_text
          ? <h3 className={`${this.props.block_name}__title`}>
              {this.props.header_text}
            </h3>
          : null}
        <ul className={`${this.props.block_name}__list`}>
          {this.props.links.map(
            (link, index) => (this.shouldRemoveLink(link) ? null : this.getLinkItem(link, index))
          )}
        </ul>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/lib/provolution/components/links_group/presentation/views/linksGroup.container.js